// removed by extract-text-webpack-plugin
module.exports = {"component":"_1KZrpPuVwK3szURSHhlDGj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Physical/ShippingForm/styles.css
// module id = 1057
// module chunks = 2